import { useBreakpoints } from 'providers/BreakpointsProvider';
import { useCallback, useMemo, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { FreeMode, Thumbs } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import type { Swiper as SwiperType } from 'swiper/types';

import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';

interface ProductGalleryProps {
  images?: string[];
}

const ProductGallery: React.FC<ProductGalleryProps> = ({ images = [] }) => {
  const { breakpoints } = useBreakpoints();
  const [thumbsSwiper, setThumbsSwiper] = useState<SwiperType | null>(null);

  const slidesPerView = useMemo(() => {
    const isMobile = breakpoints?.down?.('md') ?? true;
    return isMobile ? 3 : 5;
  }, [breakpoints]);

  if (!images.length) return null;

  return (
    <>
      <Row className="g-3">
        <Col xs={12}>
          <Swiper
            loop
            spaceBetween={12}
            modules={[FreeMode, Thumbs]}
            thumbs={{
              swiper:
                thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null
            }}
            className="rounded-3"
          >
            {images.map((src, i) => (
              <SwiperSlide key={i}>
                <div className="image-wrapper card rounded p-2 bg-white ratio ratio-1x1">
                  <img
                    src={src}
                    alt={`Product ${i}`}
                    className="w-100 h-100 rounded object-fit-cover p-1 "
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Col>

        {/* ===== Thumbnails ===== */}
        <Col xs={12}>
          <Swiper
            loop
            freeMode
            watchSlidesProgress
            spaceBetween={12}
            slidesPerView={slidesPerView}
            onSwiper={setThumbsSwiper}
            modules={[Thumbs]}
          >
            {images.map((src, i) => (
              <SwiperSlide key={i} className="h-auto">
                <div className="image-wrapper card rounded p-1 bg-white ratio ratio-1x1 cursor-pointer">
                  <img
                    src={src}
                    alt={`Thumbnail ${i}`}
                    className="w-100 h-100 rounded object-fit-cover p-1"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </Col>
      </Row>
    </>
  );
};

export default ProductGallery;
